import React, { useState } from "react";
import { CommandBarButton, Aside } from "sprint-common-web";

import { CreateSystemForm } from "../create-system-form/CreateSystemForm";

export const AddSystemButton: React.FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    return (
        <>
            <CommandBarButton onClick={openSidebar} text="Add" icon="Add" />
            <Aside isOpen={isSidebarOpen} type="form" headerText="Add System" onDismiss={closeSidebar}>
                <CreateSystemForm onCancel={closeSidebar} onSubmit={closeSidebar} />
            </Aside>
        </>
    );
};
